//export class 

import { SvgUtils } from "../utils/SvgUtils";

export interface IVisualizer {
    generate(hex: string, coreMode: boolean): SVGSVGElement;
}

export class VisualizerBase implements IVisualizer {
    placeholderMode: boolean = false;
    placeholderColor: string = "#e6e6e6";

    size: number = 320;
    centerX: number = 160;
    centerY: number = 160;
    chainIdName: string;

    hexArray: Array<string> = [];

    constructor(_chainIdName: string, _placeholderMode: boolean = false, _size: number = 320){
        this.chainIdName = _chainIdName;
        this.placeholderMode = _placeholderMode;
        this.size = _size;
    }

    generate(hex: string, coreMode: boolean = false): SVGSVGElement {
        const svg = this.createSvg();
        return svg;
    }

    generateEthereum(id: string, color: string) : SVGGElement {
        const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
        group.setAttribute("id", id);

        const path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path1.setAttribute("d", `M14.7013 0L0.652344 22.9167L14.7013 29.3333L28.7502 22.9167L14.7013 0Z`);
        if (color && color.length > 0) path1.setAttribute("fill", color);
        group.appendChild(path1);

        const path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path2.setAttribute("d", `M0.652344 27.5L14.7013 44L28.7502 27.5L14.7013 33.9167L0.652344 27.5Z`);
        if (color && color.length > 0) path2.setAttribute("fill", color);
        group.appendChild(path2);

        return group;
    }

    createSvg(): SVGSVGElement{
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svg.setAttribute("version", "1.1");
        svg.setAttribute('fill', 'none');
        svg.setAttribute('viewBox', `0 0 ${this.size} ${this.size}`);
        return svg;
    }

    getColorHex(indexR: number, indexG: number, indexB: number) {
        if( this.placeholderMode) return this.placeholderColor;
        return `#${this.hexArray[indexR]}${this.hexArray[indexG]}${this.hexArray[indexB]}`;
    }
    
    getRGBAColorHex(indexR: number, indexG: number, indexB: number, transparent: number) {
        if( this.placeholderMode) return this.placeholderColor;
        return `#${this.hexArray[indexR]}${this.hexArray[indexG]}${this.hexArray[indexB]}${transparent}`;
    }

    addUsePartToGroup(group: SVGGElement, hrefId: string, transform: string, fillColor: string = "none", strokeColor: string = "none", strokeWidth: number = 1) {
        const part = document.createElementNS("http://www.w3.org/2000/svg", "use");
        part.setAttribute("href", `#${hrefId}`);
        if (fillColor && fillColor.length > 0) part.setAttribute("fill", fillColor);
        if (strokeColor && strokeColor.length > 0) part.setAttribute("stroke", strokeColor);
        if (strokeWidth > 0) part.setAttribute("stroke-width", `${strokeWidth}`);
        part.setAttribute("transform", transform);
        group.appendChild(part);
    }

    addCircleUseToGroup(group: SVGGElement, hrefId: string, cx: number | null, cy: number | null, radius: number | null, transform: string, fillColor: string = "none", strokeColor: string = "none", strokeWidth: number = 1) {
        const part = document.createElementNS("http://www.w3.org/2000/svg", "use");
        part.setAttribute("href", `#${hrefId}`);
        if (cx) part.setAttribute("cx", `#${cx}`);
        if (cy) part.setAttribute("cy", `#${cy}`);
        if (radius) part.setAttribute("r", `${radius}`);
        if (fillColor && fillColor.length > 0) part.setAttribute("fill", fillColor);
        if (strokeColor && strokeColor.length > 0) part.setAttribute("stroke", strokeColor);
        if (strokeWidth > 0) part.setAttribute("stroke-width", `${strokeWidth}`);
        part.setAttribute("transform", transform);
        group.appendChild(part);
    }

    appendBlendStyle(svg: SVGSVGElement, mode="multiply"){
        //<style> path { mix-blend-mode: multiply; }</style>
        const s = document.createElementNS("http://www.w3.org/2000/svg", "style");
        s.innerHTML = `path { mix-blend-mode: ${mode}; }`;
        svg.appendChild(s);
    }
    appendSimpleRadialGradient(defs: SVGDefsElement, id: string, cx: number, cy: number, radius: number, color: string, zeroOffset: string) {
        const gradient = document.createElementNS("http://www.w3.org/2000/svg", "radialGradient");
        gradient.setAttribute("id", id);
        gradient.setAttribute("cx", `${cx}`);
        gradient.setAttribute("cy", `${cy}`);
        gradient.setAttribute("r", `${radius}`);
        gradient.setAttribute("gradientUnits", "userSpaceOnUse");

        const stop0 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
        stop0.setAttribute("offset", zeroOffset);
        stop0.setAttribute("stop-color", color);
        stop0.setAttribute("stop-opacity", "0");
        gradient.appendChild(stop0);

        const stop1 = document.createElementNS("http://www.w3.org/2000/svg", "stop");
        stop1.setAttribute("offset", "1");
        stop1.setAttribute("stop-color", color);
        gradient.appendChild(stop1);

        defs.appendChild(gradient);
    }

    appendMovingCirclesOutbound(svg: SVGSVGElement, radius: number) {
        const obGroup = SvgUtils.drawAnimateOutbounding2(this.chainIdName, this.centerX, this.centerY, radius,
            this.getColorHex(0, 7, 9),
            this.getColorHex(11, 15, 19),
            this.getColorHex(2, 10, 18));
        svg.appendChild(obGroup);
    }

    appendDynamicScalingOutbound(svg: SVGSVGElement, scale: number = 1.3) {
        const color = this.getRGBAColorHex(17, 18, 19, 49);
        const ob3 = SvgUtils.drawAnimateOutbounding3(this.chainIdName, this.centerX, this.centerY, color, scale);
        svg.appendChild(ob3);
    }
}